import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Element from "element-ui";
import Print from 'vue-print-nb';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import "./assets/scss/element-variables.scss";
import 'normalize.css/normalize.css';
import './assets/scss/app.scss';
import './permission';
import {
	getBirthdayFromIdCard
} from '@/tools';

Vue.use(Print);
Vue.use(html2Canvas);
Vue.use(JsPDF);
Vue.use(Element, {
	size: "small",
	zIndex: 3000
});

Vue.config.productionTip = false;

Vue.prototype.$getBirthdayFromIdCard = getBirthdayFromIdCard;

Vue.prototype.$bus = new Vue();

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
